"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadPage = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var LoadingIndicator_1 = require("@app/components/LoadingIndicator");
var Page_1 = require("@app/components/layout/Page");
var UploadForm_1 = __importDefault(require("@app/features/transfers/components/upload/UploadForm"));
var PendingPackages_1 = __importDefault(require("@app/features/pending-uploads/components/PendingPackages"));
var config_1 = require("@app/shared/config");
var selectors_1 = require("@app/features/transfers/state/selectors");
var UploadPage = /** @class */ (function (_super) {
    __extends(UploadPage, _super);
    function UploadPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UploadPage.prototype.render = function () {
        var packageId = this.props.match.params.packageId;
        var creatingPackageTitle = react_1.default.createElement("h1", null, "Creating Package");
        return (react_1.default.createElement(Page_1.Page, { title: "Upload Package", isAsperaInitializing: this.props.asperaInitializing, isLoading: !this.props.asperaLoaded },
            react_1.default.createElement(UploadForm_1.default, { maxTotalSize: config_1.Config.HTTP_TRANSFER_MAX_PACKAGE_SIZE, packageId: packageId }),
            react_1.default.createElement("div", { className: "columns" },
                react_1.default.createElement("div", { className: "column" },
                    react_1.default.createElement(PendingPackages_1.default, null))),
            this.props.isUploading &&
                react_1.default.createElement(LoadingIndicator_1.LoadingIndicator, { title: creatingPackageTitle })));
    };
    return UploadPage;
}(react_1.Component));
exports.UploadPage = UploadPage;
var mapStateToProps = function (store) {
    return {
        asperaInitializing: selectors_1.isAsperaInitializing(store),
        asperaLoaded: selectors_1.isAsperaLoaded(store),
        isUploading: store.transfers.isUploading,
        isUserInternal: store.auth.userInfo ? store.auth.userInfo.isInternal : false
    };
};
exports.default = react_redux_1.connect(mapStateToProps)(UploadPage);
